import type { ThemeComponentType } from '../types';

export const Alert: ThemeComponentType = {
  styles: (theme, { color, variant }) => ({
    root: {
      // borderColor: color ? theme.colors[color][2] : theme.colors.gray[2],
      padding: theme.other.spacing(1.5),
      backgroundColor: color ? theme.colors[color][1] : theme.colors.gray[1],
    },
    label: {
      color: theme.black,
      fontSize: theme.fontSizes.md,
      marginTop: -2,
    },
    message: {
      fontSize: theme.fontSizes.md,
    },
    icon: {
      marginTop: 0,
      marginRight: theme.other.spacing(1),
      width: 'fit-content',
      height: 'fit-content',
    },
    title: {
      minHeight: 24,
      marginBottom: 0,
    },
  }),
};
